import { createAsyncThunk } from '@reduxjs/toolkit';
import { PropertyFacility } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchPropertyFacility,
  FindPropertyFacility,
  GetPropertyFacility,
} from './interface';

export const findPropertyFacility = createAsyncThunk(
  'propertyFacility/findPropertyFacility',
  async (values: FindPropertyFacility, { rejectWithValue }) => {
    try {
      const response = await PropertyFacility.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPropertyFacility = createAsyncThunk(
  'propertyFacility/createPropertyFacility',
  async (values: CreatePatchPropertyFacility, { rejectWithValue }) => {
    try {
    
      const response = await PropertyFacility.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPropertyFacility = createAsyncThunk(
  'propertyFacility/patchPropertyFacility',
  async (
    { id, ...values }: CreatePatchPropertyFacility,
    { rejectWithValue }
  ) => {
    try {
      const response = await PropertyFacility.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPropertyFacility = createAsyncThunk(
  'propertyFacility/getPropertyFacility',
  async ({ id }: GetPropertyFacility, { rejectWithValue }) => {
    try {
      const response = await PropertyFacility.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);